import { useQuery } from "@apollo/client";
import {
  AccountBalance,
  AccountBalanceWallet,
  Handshake,
  Money,
  Payment,
  Person,
  Pin,
  Receipt,
  Troubleshoot,
} from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";
import Toaster from "common/Toaster";
import DetailCard from "common/detailElement/DetailCard";
import DetailList from "common/detailElement/DetailList";
import moment from "moment";
import { useParams } from "react-router-dom";
import { GET_SINGLE_INVOICE_RECEIPT } from "./graphql/query";

import { CalendarMonth, EditCalendar } from "@mui/icons-material";
import CButton from "common/CButton";
import LinkTag from "common/LinkTag";
import RenderStatus from "common/Table/renderCell/RenderStatus";
import DetailPageLoading from "common/detailElement/DetailPageLoading";

const iconStyle = { color: "rgba(0,0,0,0.7)" };

const InvoiceReceiptDetail = () => {
  const { id } = useParams();

  const { data, loading } = useQuery(GET_SINGLE_INVOICE_RECEIPT, {
    skip: id ? false : true,
    onError: (error) => {
      Toaster({
        type: "error",
        message: error.message,
      });
    },
    variables: { objectId: id },
  });

  if (loading) {
    return <DetailPageLoading />;
  }

  let packageBooked = data?.invoiceReceipt?.packages?.edges?.[0]?.node;

  let packageOf = packageBooked?.membershipPackage
    ? "membershipPackageBookings"
    : packageBooked?.dietPlanPackage
    ? "nutritionPlanPackageBookings"
    : packageBooked?.personalTrainingPackage
    ? "personalTrainingPackageBookings"
    : "";

  return (
    <Box>
      <Box>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6" mb={2} color="#0a0a0a">
            Invoice Receipt Details
          </Typography>
          <Box>
            <LinkTag to={`/admin/${packageOf}/invoiceReceipt/${id}`}>
              <CButton label="View Receipt" />
            </LinkTag>
          </Box>
        </Box>
      </Box>
      <DetailCard>
        <Grid container>
          <Grid item xs={12} md={6}>
            <DetailList
              title="Customer Name"
              data={
                <LinkTag
                  to={`/admin/members/${data?.invoiceReceipt?.customer?.user?.memberInfo?.objectId}`}
                >
                  {data?.invoiceReceipt?.customer?.user?.name}
                </LinkTag>
              }
              icon={<Person sx={iconStyle} />}
            />

            {packageBooked?.membershipPackage ? (
              <DetailList
                title="Package"
                data={
                  <LinkTag
                    to={`/admin/membershipPackages/${packageBooked?.membershipPackage?.package?.objectId}`}
                  >
                    {packageBooked?.membershipPackage?.package?.name}
                  </LinkTag>
                }
                icon={<Person sx={iconStyle} />}
              />
            ) : null}

            {packageBooked?.dietPlanPackage ? (
              <DetailList
                title="Package"
                data={
                  <LinkTag
                    to={`/admin/dietPlanPackages/${packageBooked?.dietPlanPackage?.package?.objectId}`}
                  >
                    {packageBooked?.dietPlanPackage?.package?.name}
                  </LinkTag>
                }
                icon={<Person sx={iconStyle} />}
              />
            ) : null}

            {packageBooked?.personalTrainingPackage ? (
              <DetailList
                title="Package"
                data={
                  <LinkTag
                    to={`/admin/personalTrainingPackage/${packageBooked?.personalTrainingPackage?.package?.objectId}`}
                  >
                    {packageBooked?.personalTrainingPackage?.package?.name}
                  </LinkTag>
                }
                icon={<Person sx={iconStyle} />}
              />
            ) : null}

            <DetailList
              title="Created On"
              data={moment(data?.invoiceReceipt?.createdOn).format(
                "DD MMM YYYY hh:mm a"
              )}
              icon={<EditCalendar sx={iconStyle} />}
            />
            <DetailList
              title="Bank"
              data={data?.invoiceReceipt?.bank?.name ?? "-"}
              icon={<AccountBalance sx={iconStyle} />}
            />
            <DetailList
              title={
                data?.invoiceReceipt?.paymentType === "card"
                  ? "Card No"
                  : "Cheque No"
              }
              data={data?.invoiceReceipt?.chequeNo ?? "-"}
              icon={<Pin sx={iconStyle} />}
            />
            <DetailList
              title="Cheque Amount"
              data={data?.invoiceReceipt?.chequeAmount ?? "-"}
              icon={<Money sx={iconStyle} />}
            />
            <DetailList
              title="Cheque Date"
              data={data?.invoiceReceipt?.chequeDate ?? "-"}
              icon={<CalendarMonth sx={iconStyle} />}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <DetailList
              title="Email Delivery Status"
              data={
                <>
                  {data?.invoiceReceipt?.deliveryReport &&
                  JSON.parse(data?.invoiceReceipt?.deliveryReport) ? (
                    <RenderStatus
                      style={{ width: "140px" }}
                      value={
                        JSON.parse(data?.invoiceReceipt?.deliveryReport)
                          ?.delivered
                          ? "delivered"
                          : "not-delivered"
                      }
                    />
                  ) : (
                    <RenderStatus value={"not-delivered"} />
                  )}
                </>
              }
              icon={<Troubleshoot sx={iconStyle} />}
            />
            <DetailList
              title="Created By"
              data={data?.invoiceReceipt?.createdBy?.name ?? "-"}
              icon={<Person sx={iconStyle} />}
            />
            <DetailList
              title="Payment Type"
              data={data?.invoiceReceipt?.paymentType}
              icon={<Payment sx={iconStyle} />}
            />
            <DetailList
              title="Invoice Amount"
              data={data?.invoiceReceipt?.invoiceAmount}
              icon={<Receipt sx={iconStyle} />}
            />
            <DetailList
              title="Paid Amount"
              data={data?.invoiceReceipt?.paidAmount}
              icon={<Handshake sx={iconStyle} />}
            />
            <DetailList
              title="Balance"
              data={data?.invoiceReceipt?.balance}
              icon={<AccountBalanceWallet sx={iconStyle} />}
            />
          </Grid>
        </Grid>
      </DetailCard>
    </Box>
  );
};

export default InvoiceReceiptDetail;
